/* eslint-disable max-lines */
/* eslint-disable max-len */

export default {
  lang: 'English',
  homeScreen: {
    title: '', // Product specific
    stayConnected: 'Stay Connected',
    comingSoon: 'Coming Soon',
    downloadNow: 'Download now:',
    readMore: 'Read More >',
  },
  glassWidgets: {
    errors: {
      requestFailed: 'Something went wrong. Please try again later.',
    },
    programStatus: {
      title: 'My Status',
      loading: 'Loading…',
      yourRep: 'Your Rep',
      myProfile: 'Profile',
      favorites: 'Favorites',
      registeredOn: 'Joined on:',
      graduatedOn: 'Graduated on:',
      totalBadgesEarned: 'Total Badges Earned:',
      lastBookingLogged: 'Last Booking Logged:',
      currentTier: 'Current Tier',
      lastBadgeEarned: 'Last Badge Earned:',
      currentFocus: 'Current Focus:',
    },
    todaysfocus: {
      title: "Today's Focus",
      empty: 'No focus items for today',
      loading: 'Loading…',
      error: 'Something went wrong',
      slideNavAria: 'Slide navigation',
      slideAria: 'Slide',
      carouselAria: "Today's focus",
    },
    welcome: 'Welcome!',
    welcomeBack: 'Welcome back, {firstName}!',
    notifications: {
      loading: 'Loading…',
      empty: 'No notifications',
    },
    achievements: {
      title: 'Rewards & Contests',
      loading: 'Loading…',
      lastBooking: 'Last Entry Submission',
      currentTier: 'Current Tier',
      contestEntries: 'Total Contest Entries',
      nightsBooked: 'Nights Booked',
      totalRevenue: 'Total Revenue Reported',
      noBookingData: 'No booking data available.',
      fileUploadSuccess: 'File has been uploaded successfully.',
      quickSubmit: {
        title: 'Quick submit',
        uploading: 'Uploading…',
        clear: 'Clear',
        submit: 'Submit',
        submitSuccessSimulated: 'Booking submitted successfully',
      },
    },
  },
  profileImageView: {
    currentImage: 'Your current profile image:',
    uploadImage: 'Upload your profile image:',
    chooseAFile: 'Choose a file…',
    cancel: 'cancel',
    backButton: 'Go Back',
    uploadButton: 'Upload profile image',
    saveButton: 'Save this profile image',
    fileTooLargeTitle: 'Uploading size exceeded',
    fileTooLargeText: 'Max image upload size is 10mb',
  },
  notification: {
    newAndNow: 'New & Now!',
    alert: 'Alert',
    message: 'Message',
    badge: 'New Badge',
    contest: 'Contest',
    'content-update': 'Content Update',
    events: 'Events',
    other: 'Notification',
    welcome: 'Welcome',
  },
  sharing: {
    email: 'Email',
    download: 'Download',
    copyURL: 'Copy Link',
    copied: 'Copied',
    shareSubjectBadge: 'Check out this awesome resource!',
    shareBodyBadge: 'I just earned this badge. Check it out!',
  },
  announcements: {},
  loginScreen: {
    version2: {
      homeTitle: "Let's see if we can find an existing profile for you in our system.",
      homeTitleSub: 'Enter the email address you typically use to login to training programs.',
      noAccount: 'No account found ({email}), please try with another email or create an account now.',
      continueButton: 'Continue',
      success: 'Successfully updated your account! You will be redirected shortly to the home page.',
      successNewAccount: 'To complete your registration, you will receive a confirmation email to verify your account.',
      loginButton: 'Login',
      matchFound: 'We have found a match, please fill in your password to continue.',
      magicLink: 'Login via a link in your email:',
      magicLinkButton: 'Request Magic Link',
      magicLinkTitle: 'Get a direct link sent to your email that will sign you in instantly.',
      otherEmailButton: 'Submit',
      title:
        'Please take a moment to complete all the information below as it will populate your personal profile and contact information.',
      titleIndustry:
        'Please take a moment to complete all the information below as it will populate your personal profile and contact information.',
      register: 'Create an account',
      agent: 'Travel Advisor',
      visitor: 'Industry Visitor',
      step1: 'Step 1: Type of User',
      step2: 'Step 2: Create An Account',
      step3: 'Step 3: Create Your Profile',
      marketingOptIn: 'Are you sure you are not interested in staying connected to this program’s travel trade team?',
      optIn: 'Yes, I’m Interested',
      optOut: 'Not Interested',
      step2Sub1: 'Tell Us About Yourself',
      step2Sub2: 'Tell Us About Your Business',
      privacyHead: 'COMMUNICATIONS PREFERENCES',
      privacySub:
        'Check the boxes below to ensure you receive important communications from the supplier’s travel trade team (product updates and announcements, rewards, incentives, FAMs, etc.) and travel trade networking and sales support initiatives from TravPRO Mobile.',
      privacy: 'We protect your privacy and never sell, misuse or betray your trust.',
      store: 'Easily download this program at your app store:',
      powered: 'POWERED BY',
      toastMessage: {
        forgotSuccess:
          'We have e-mailed your password reset link! You will be redirected to the login page in 10 seconds.',
        emailNotExisting: "The email address you entered doesn't exist.",
        magicLinkMessage: 'Please wait, we are signing you in right now.',
        magicLinkError:
          "We couldn't find your account in our database, please log in manually. You will be redirected in 10 seconds.",
        magicLinkError1:
          "We couldn't find a valid token, please login or request a new magic link. If this problem persists, please contact us at: info@travpromobile.com.",
        magicLinkError2:
          "We couldn't find your account in our database, please log in manually. You will be redirected in 10 seconds.",
        magicLinkSuccess: "Check your email at {email}. It has a magic link that'll sign you in.",
        magicLinkErrorWait: 'Please wait 5 minutes in between magic link requests.',
        emailNotFoundError:
          'The email address you entered can’t be found in our records. Please check for misspellings or create an account.',
      },
      errors: {
        zipCodeNotFound: 'ZipCode not found, try again',
        zipCodeOnlyNumbers: 'ZipCode can only contain numbers',
        password: 'Please enter a password',
        passwordNotMatching: 'The passwords you entered do not match',
        passwordTooShort: 'Password needs to be at least 8 characters',
        emailExists:
          'This email address already exists or is invalid. Please try with another email address or login to your account.',
        fillInAllFields: 'Please fill in all the required fields',
        fillInEmail: 'Please fill in your email.',
        emailNotExisting: "The email address you entered doesn't exist.",
      },
      fields: {
        forgotSubCopy: 'Forgot your password & want to change it? ',
        forgotSubCopy2:
          'Want to bypass password entirely? We will send you an email with a magic link that will automatically log you into the program. ',
        city: 'City',
        companyName: 'Company Name',
        role: 'Your Role',
        description: "Which best describes your company's business?",
        country: 'Country',
        password: 'Password',
        passwordRegister: 'Choose Password (8 character minimum)',
        passwordConfirm: 'Confirm Password',
        firstName: 'First Name (Given)',
        lastName: 'Last Name (Family)',
        agency: 'Your Agency Name',
        title: 'Your Role (Select One)',
        company: 'Company Name',
        select: 'Select an option below',
        state: 'State',
        province: 'Province/Region/State',
        zipCode: 'Zip Code',
        postalCode: 'Postal Code',
        affiliate: 'Which group is your MAIN agency affiliation?',
        hostAgency: 'Your Host Agency?',
        executive: 'Executive',
        management: 'Management',
        marketing: 'Marketing',
        sales: 'Sales',
        coordinator: 'Coordinator',
        opt: 'Stay connected to the Brand USA team and receive USA Discovery Program updates.',
        optMarketing: 'Stay connected to TravPRO to hear about additional learning programs.',
        retail: 'Retail Store Front',
        home: 'Home-Based Agent',
        independent: 'Independent Contractor',
        host: 'Host Agency',
        call: 'Call Center or Web-Based Agency',
        other: 'Other ',
        describes: 'What best describes you and your agency’s business? ',
      },
    },
    title: 'Travel Professional Training and Sales Enablement Program', // Product specific (TravPRO text or ChannelPRO text)
    welcome: {
      headerTop: 'Welcome to the',
      headerBottom: 'USA Discovery Program', // Product specific
    },
    sellingPoints: {
      // All selling points can be product specific
      0: 'Learn, Promote & Sell on the Go',
      1: 'Multi-media Training Across Devices',
      2: 'Certificate of Completion',
      3: 'Ready-made Sales Presentations',
      4: 'High-impact Promotional Materials',
      5: 'Insider Tips & Promotions',
      6: 'Real-time Product Directory',
      7: 'Timely News & Updates',
    },
    emailPrompt: 'Please enter your email address and password to confirm that you are a travel professional.', // Product specific (TravPRO or ChannelPRO text)
    tAndC: {
      agree: 'By continuing you agree with our ',
      privacyPolicy: 'privacy policy',
      and: ' and ',
      termsConditions: 'terms and conditions',
    },
    fields: {
      select: 'Select an option below',
      country: 'Country',
      agency: 'Agency',
      email: 'Email',
      password: 'Password',
      passwordConfirm: 'Confirm your password',
      firstName: 'First name',
      lastName: 'Last name',
      address: 'Address',
      postalCode: 'Zip Code',
      city: 'City',
      agencyName: 'Agency Name',
      stateProvince: 'State / Province',
      required: 'Required',
      invalidEmail: 'Invalid email address',
      opt: "Stay In Touch! Yes, I'd like to opt in to communications from Destionation Brand USA that will keep me posted on news, events, incentives, FAM’s and more!",
      forgot: 'Forgot your password? Click the button below and we’ll send you an email to reset your password.',
    },
    forgot: 'Reset Password',
    noAgent: {
      noAgentButton: "I'm not an agent",
      title: 'Thank you for your interest in the USA Discovery Program.', // Product specific
      messageWeb:
        'The content on this site is exclusively for travel professionals. \n To learn more about Brand USA, please visit: ', // Product specific
      messageMobile:
        "Some content on this app is exclusively for travel professionals, but feel free to browse a preview of what this app has to offer by pressing 'Continue'.", // Product specific
      continue: 'Continue',
      visitWebsite: 'Visit website',
    },
    newUser: 'New User',
    register: 'Register',
    registered: 'This email is already registered',
  },
  welcomeScreen: {
    title: 'Welcome to the USA Discovery Program', // Product specific
    helloUser: 'Hello {{name}}',
    hello: 'Hello,',
    fromAgency: 'from {{agency}}',
    notUser: 'Not {{name}}?',
    introOnline: "Train immediately online or preload the content so it's always available for offline use!",
    introOffline: 'You already have the latest version preloaded. Start training or selling anytime, anywhere!',
    startTraining: 'Start learning',
    continueTraining: 'Continue learning',
    graduated: 'Congratulations!',
    downloader: {
      preload: 'Preload',
      stop: 'stop',
      init: 'Initializing...',
      lastUpdate: 'Last update: ',
    },
  },
  trainingScreens: {
    comingSoon: 'Coming Soon: {title}',
    categoryLockMinimum: 'Unlock at least {number} included training to access this category.',
    allUnlocked: 'You have unlocked all chapters!',
    completedBase: 'Congratulations, you are a certified USA Specialist!',
    certificate: 'Certificate',
    chapter: 'Chapter',
    chapterComplete: 'Chapter complete!',
    choose: 'Please choose an answer',
    completed: 'Completed',
    confirm: 'Confirm your answer',
    continue: 'Continue',
    welcome:
      'Simply complete modules to gain points towards your ultimate goal of becoming a Gold Brand USA Specialist. The bar along the right will show you exactly how you’re doing.',
    courseComplete: 'Course complete!',
    durationInMinutes: '{number} minutes',
    endReached: "You've reached the end",
    essential: 'The Foundation',
    essentialSub: 'Complete these essential chapters to earn your diploma and unlock the specializations below.',
    message: '{count} Message',
    messagePlural: '{count} Messages',
    percentageComplete: '{number}% Complete',
    partnerBadgeincentives: 'Partner Badge \n Incentive',
    restart: 'Review',
    review: 'Review',
    retainEnd: 'Use the top bar to navigate around in this chapter or press the back button to return to the overview.',
    retry: 'Try Again',
    skip: 'Return >',
    viewAllTitle: 'Training Tip',
    badge: 'download \n badge',
    viewAll:
      'Before you proceed to the next page, please take a moment to review all the content here, including the icons, as they offer additional information to help you become an expert.',
    specialization: 'Specialization Modules',
    specializationSub: 'Finish these modules to Achieve Your Silver Brand USA Specialist Status',
    start: 'Start',
    status: 'Current Status:',
    tip: 'You earn your status by completing<br />the modules within each tier. <br />Dream big and reach Gold Brand USA Specialist status<br />by completing all modules!',
    trouble: "It looks like you're having trouble, please re-read the content on the previous page(s) and try again.",
    unlockDefault: 'Unlock this chapter by completing the previous one.',
    unlock: 'Unlock this chapter by completing training chapter.',
    unlockSubtitle: 'Unlock more chapters by completing training chapters.',
    unlockFoundation: 'Unlock these chapters by completing The Foundation.',
    watchListenRead: 'Watch, Listen & Read more',
  },
  trainingExtraScreens: {
    subtitle: 'EXPERIENCES',
    facts: 'Facts',
    noFactsFound: {
      title: 'No facts found',
      description: 'No facts found for this category.',
    },
    error: 'Oops. Something went wrong',
    uncompletedTitle: 'UNCOMPLETED {partner} EXPERIENCES',
    completedTitle: 'COMPLETED {partner} EXPERIENCES',
    noAvailableBadges: 'There are currently no badges available yet.',
    interimScore: 'Complete',
    interimScoreEnd: 'more chapters to earn your badge.',
    badgesComplete: 'Congratulations! You have earned your badge:',
  },
  newTrainingFlow: {
    tip: 'tip: You earn your status by completing the modules within each tier.  Dream big and reach Gold Brand USA Specialist status by completing all modules!',
    essentialModules: 'Essential Chapters',
    finishBronze: 'Complete these essential modules to earn BRONZE status and move on to the next section.',
    specializationModules: 'Specialization Modules',
    finishSilver:
      'Explore Brand USA’s incredible activities & adventures to achieve SILVER status and receive your diploma!',
    partnerModules: 'PARTNER SPECIALIZATIONS',
    finishGold: 'Get to know our partners and earn badges by completing these chapters.',
    currentStatus: 'Current Status',
    pointsToLevel: '{pointsToLevel} {points} ',
    reachedRanking: 'until you have reached the {rank} ranking!',
    outOf: '{points} XP out of',
    pointsToRank: '{pointsToLevel} XP needed to rank:  ({rank})',
  },
  popUp: {
    bronze:
      'Nice work! You’ve learned all about the essentials of Brand USA and have earned BRONZE status. Next, we’ll explore the many types of experiences visitors can have here.',
    silver:
      'Congratulations! You have earned your diploma as a certified Brand USA Specialist by successfully completing all modules in The Foundation and The Experience. You have also achieved SILVER status and are ready to go for GOLD and beyond by proceeding into the Provinces, Territories & Cities section below. Keep up the great work!',
    gold: 'Great work! You have successfully completed 10 Provinces, Territories & Cities modules and have now earned GOLD status. Choose to complete another 12 and you become a full PLATINUM-level Brand USA Specialist!',
    platinum:
      'Congratulations!! You have earned PLATINUM status — the highest level of qualification as a certified Brand USA Specialist. Thank you for all your hard work and your partnership in selling Brand USA.',
  },
  points: {
    pointsToLevel: '{pointsToLevel} {points} until you have reached the {rank} ranking!',
    outOf: '{points} XP out of',
    unit: 'XP',
    pointsToRank: '{pointsToLevel}XP needed to rank:  ({rank})',
    complete: {
      chapter: 'Chapter complete!',
      'intro-chapter': 'Intro Chapter complete!',
      'sub-app': 'SubApp complete!',
      rewards: 'Rewards complete!',
      multi: "You're due some points!",
    },
    completed: '{completed} Badges Earned',
  },
  nav: {
    home: 'Home',
    train: 'Train',
    learn: 'Train',
    retain: 'Retain',
    directory: 'Directory',
    showRoom: 'Hotel Spotlights',
    showcases: 'Showcases',
    promote: 'Promote',
    sell: 'Sell',
    info: 'Info',
    rewards: 'Rewards',
    media: 'Media',
    favorites: 'Favorites',
    contact: 'Connect with Us',
    reportCard: 'View Report Card',
    diploma: 'View Diploma',
    accountSettings: 'Account Settings',
    messages: 'Messages',
    search: 'Search',
  },
  contentHeaders: {
    train: 'Train',
    retain: 'Retain',
    subapps: 'PARTNER SPECIALIZATIONS',
    maintrainings: 'Locations',
    subtrainings: 'The Experiences',
    itineraries: 'ITINERARIES',
    leaderboard: 'Prize Center',
    dashboard: 'How to Earn More Rewards?',
  },
  pageDescriptions: {
    train: 'Educate, engage and become the expert.',
    showroom: '',
    retain: 'Retain your expert knowledge with this easy-to-use content resource.',
    promote: 'Share these items to ignite interest and start a conversation with clients and prospects.',
    sell: 'Answer client questions and engage with Brand USA.',
    favorites: 'Check out your personally favorited content',
    search: 'Look through all content',
    subapps: 'Get to know our partners and earn badges by completing these chapters.',
    maintrainings: 'Complete these regions to earn BRONZE status and move on to the next section.',
    subtrainings: 'Enhance your expertise and earn a badge for each section below.',
    itineraries: 'Complete these quick chapters on popular Road Trips and earn a badge for each.',
    leaderboard:
      'Brand USA will host a FAM trip for advisors annually and the Top 5 on this list will ensure themselves an invitation :) Over the course of the year you can check in here to see where you stand in terms of the Top 5.   To the right you can see all the ways to earn more points and perks. Good luck and enjoy the friendly competition!​​',
    dashboard:
      'Earning more cash, points and perks from Brand USA is simple.  This dashboard will help you quickly see what has been already been accomplished, and what can still be done to earn like training and sharing with clients... \n\n The most earning potential comes from booking a Brand USA property and reporting the booking on the Submit Booking tab on the left.​',
  },
  general: {
    website: 'https://www.thebrandusa.com/',
    forgot: 'Forgot Password?',
    next: 'Next',
    yes: 'Yes',
    no: 'No',
    previous: 'Previous',
    submit: 'Submit',
    register: 'Register',
    back: 'Back',
    close: 'Close',
    page: 'Page',
    search: 'Search',
    logIn: 'Log in',
    logOut: 'Log Out',
    viewItem: 'View {type}',
    imageNotFound: 'Image not found',
    noResultsFor: 'No results have been found for: {{query}}',
    noFavorites: "You don't have any favorites yet.",
    noMessages: "You haven't received any messages yet!",
    resultsFor: 'Results for: {{query}}',
    showAll: 'Show all',
    showcases: 'Partner Showcases',
    connectionError: 'Connection error',
    alreadyExists: 'Already exists',
    pageNotFound: '404 Page Not Found!',
    oops: 'Uh oh...',
    overview: 'Return to overview',
    complete: 'Continue',
    courseComplete: 'Chapter Complete!',
    chapterComplete: 'Chapter Completed!',
    message: 'Message ({count})',
    messagePlural: 'Messages ({count})',
  },
  itemTypes: {
    image: 'Image',
    brochure: 'Collection',
    layout: 'Layout',
    web: 'Website',
    pdf: 'PDF',
    carousel: 'Collection',
  },
  questions: {
    dials: 'Rotate the dials to match the answer',
    fitb: 'Fill in the blank(s)',
    flip: 'Change the number to match the answer',
    multipleChoice: 'Pick the right answer(s)',
    slider: 'Pick the right answer using the slider',
    map: 'Answer the question by tapping the right location on the map',
    dropdown: 'Choose...',
    true: 'True',
    false: 'False',
  },
  reportCard: {
    download: 'Download',
    email: 'Email',
    print: 'Print',
  },
  cookies: {
    consent: 'AGREE',
    optout: 'Opt-out',
    settings: 'Privacy Settings',
    message:
      "You haven't told us anything about your data privacy preferences! That's ok, but we'd like to offer you the best experience using the Sales Companion.",
    disabled: 'It looks like you have disabled the use of cookies.',
    use: 'The {{appName}} requires the use of cookies to deliver you the best experience.',
    details: 'What are the cookies used for?',
    enable: 'See how to enable your cookies {{here}}.',
    here: 'here',
  },
  notLoggedIn: {
    super: "You're not logged in",
    title: 'You need to be logged in to view this content',
    guest: 'Guest',
  },
  demo: {
    message: 'This website is a demo of the final product. It is currently in-development and not a complete product.',
    consent: 'Understood!',
  },
  share: {
    header: 'Share this resource on your favorite social media!',
    download: 'Download',
    email: 'Email',
  },
  breadCrumbs: {
    page: 'Page',
  },
  storeButtons: {
    title: 'Get the app on your mobile device',
  },
  onMobile: {
    header: "It looks like you're trying to access the {appName} app from a mobile device",
    body: 'To download this program simply visit your app store and search for {appName} or click one of the buttons below',
    benefits: {
      header: 'This will provide you with:',
      1: 'Learn, Promote & Sell on the Go',
      2: 'Multi-media Training Across Devices',
      3: 'Certificate of Completion',
      4: 'Ready-made Sales Presentations',
      5: 'High-impact Promotional Materials',
      6: 'Real-time Product Directory',
      7: 'Timely News & Updates',
    },
  },
  custom: {
    splitUsers: 'I Am A ...',
    brandAmbassador: 'Brand Ambassador',
    travelPro: 'Travel Professional',
  },
  rewards: {
    rewards: 'Rewards',
    title: 'Welcome to the Rewards & Achievements Center',
    subheader: 'Track and Share Training Achievements and Incentives',
    subTitle:
      'We’re giving you a chance to win rewards for becoming a specialist with our program, and booking travel to The Brand USA!',
    body: 'Book travel to The Brand USA for your chance to win! Enter your bookings for eligibility to earn an Introductory Incentive Reward of $5 US/CAN E-gift Card.',
    item1:
      'After your first confirmed booking of 4-nights or more, (for an individual reservation), for a minimum of two (2) passengers, at a qualifying hotel/resort. (Cruises do not qualify.)',
    item2: 'Offer valid after Essential Modules of the USA Discovery Programme Program are completed.',
    link1: 'Have you booked the Brand USA? ',
    link2: 'If so, submit your booking here.',
    button: 'Submit your booking',
    products: 'Marketplace',
    viewAllBookings: 'Bookings',
    viewLeaderboard: 'Leaderboard',
    viewDashboard: 'Points Dashboard',
    viewRewards: 'Overview',
    overview: {
      title: 'Earn Points & Cash rewards for your Brand USA training, sharing and bookings.*',
      grand: 'Cash Rewards for Every Booking More Than 3 Nights',
      grandPrize: 'USD $50 per every 3-5 nights stay',
      grandPrizeSecond: 'USD $100 per every 6+ Nights stay',
      first: 'Monthly Prizes',
      firstPrize:
        'Chances to win part of $500 for the travel advisors booking the highest number of guests to any Brand USA property.',
      second: 'Grand Prizes',
      secondPrize:
        'Rooms, Upgrades, Site inspection FAMs., Swag, and more to surprise and delight our valued advisors.',
      choosen: 'Point Based Redemption Marketplace',
      choosenPrize:
        'Use point that you earn along the way for ALL activities including booking submissions, training, and sharing ccollateral with your clients.',
      valid: "*Bookings entered are valid only after client's travel is completed.",
    },
    home: {
      entries: 'Current Entries',
      trainingAchievements: 'TRAINING ACHIEVEMENTS',
      trainingAchievementsText:
        'Track your training progress, certifications, and metallic rewards status on this page. You’ll also be able to download and share your USA Specialist diploma, as well as any badges you’ve earned in Experiences and Partner Specializations.',
      bookingContests: 'BADGE INCENTIVES',
      bookingContestsText: 'Complete, track and manage your Badge Incentives here.',
      submitBooking: 'SUBMIT BOOKINGS',
      submitBookingText: 'This is where you’ll submit bookings for inclusion in Booking Incentives.',
      currentContest: 'CURRENT INCENTIVE',
      currentContests: 'CURRENT INCENTIVES',
      noContests: 'There are no current badge incentives. Check back soon!',
      ContestEndDate: 'Incentive Ends:',
      ContestDetails: 'Incentive Details',
      ContestSeeProgram: 'See program',
      ContestTerms: 'Terms & Conditions',
      ContestForDetails: 'for details.',
      ContestPartnerLink: 'Go to Partner',
      ContestLink: 'Go to Link',
    },
    bookingRewardsView: {
      title: 'Marketplace',
    },
    bookingsView: {
      title: 'Bookings',
      infoMessage:
        'Sort using buttons above and click any record to manage submission details. All pending entries will be verified within 72 hours.',
    },
    leaderboardScreen: {
      title: 'POINTS \n Leaderboard',
      earnedpts: 'MY POINTS EARNED​:',
      pointsWall: 'POINTS TOP 5 TRACKER​:',
      startEarning: "Start now earning XP's and join the leaderboard!",
      prizes: 'Prizes',
      tAndC: 'Terms and Conditions apply*',
      pointsOverview: {
        title: 'How to earn points',
        booths: 'Visit Exhibitor Showcases',
        breakoutSessions: 'Attend Breakout Sessions & Destination Spotlights',
        trainingSessions: 'Complete a Training Chapter',
        adventureSpotlights: 'Family Travel Tips',
        share: 'Sharing Content',
        shareMax: '(up to {maxSharePoints} points)',
        shareInfo:
          'Sharing is counted by sharing booth content to Twitter and Facebook or sharing the entire booth with colleagues or clients.',
        viewVideo: 'View Video',
      },
    },
    dashboardView: {
      title: 'Badge Incentives',
      subtitle: 'Complete, track and manage your Badge Incentives here.',
      badge: 'Badges',
      activity: 'Bookings Dashboard',
      manage: 'Manage Bookings',
      manageSub: 'Track current bookings below, or view archived bookings by using the dropdown.',
      noBadgeIncentives: 'There are no current badge incentives. Check back soon!',
      noBookings: 'There are no records to display.',
      state: {
        approvedEntries: 'Approved Entries',
        pendingEntries: 'Pending Entries',
        declinedEntries: 'Declined Entries',
        viewAll: 'View All',
      },
      currentYear: 'Current Year',
      archivedBookings: 'Archived Bookings'
    },
    bookingForm: {
      title: 'USA Booking Credit Form',
      subTitle: 'Enter your booking:',
      required: '* Indicates a required field',
      email: 'Advisor email',
      agentFirstName: 'Advisor First Name',
      agentLastName: 'Advisor Last Name',
      company: 'Agency / Company Name',
      iata: 'IATA/CLIA #',
      stateProvince: 'State/ Province',
      postalCode: 'Zip / Postal Code',
      country: 'Country',
      city: 'City',
      birthday: 'Birthday',
      type: 'Guest Trip Type',
      source: 'Booking Source',
      tourOperator: 'Tour Operator',
      firstName: 'Guest First Name',
      lastName: 'Guest Last Name',
      confirmNumber: 'Booking Confirm Number / PNR Number',
      ticketNumber: 'Ticket Number',
      file: 'RezSnap™ Proof Upload ',
      arrivalDate: 'Property Arrival Date',
      departureDate: 'Property Departure Date',
      brand: 'Brand Booked',
      lengthOfStay: 'Length of Stay',
      cost: 'Total Cost of Booking',
      rooms: 'Number of Rooms',
      airline: 'Airline/ Carrier (2- digit code)',
      gateway: 'Origin Gateway (3- letter airport code)',
      destination: 'Destination/ island (3- letter airport code)',
      disclaimer: '* Required fields',
      button: 'Submit your booking',
      sub: 'Your information',
      sub2: 'Booking information',
      travelDepartureDate: 'Travel Departure Date',
      travelReturnDate: 'Travel Return Date',
      flightNumber: 'US Bound Flight Number',
      numberOfTravelers: 'Number of Travelers in Party',
      edit: 'Edit your info',
      fileUploaded: 'File has been uploaded successfully',
      select: 'Please select an option below',
      drag: 'Drag and drop a file here, or click to select a file.',
      fileType: '(One file, .jpeg, .png and .pdf files will be accepted. Max file size is 100 MB.)',
      maxSize: 'Max file size is 100mb',
    },
    TermsAndConditions: {
      title: 'Terms and Conditions',
      subTitle: 'Bahamas Specialist Quarterly Rewards',
      body1:
        'All posting must be accompanied by a zero-balance proof of sale document that corresponds with each individual booking that you have posted. Awardees will be selected based on the totality of verified proof of sale documents corresponding with each listed booking. Postings must follow all USA Discovery Program rules for eligibility.',
      body2:
        'To be eligible you must reside in the U.S or Brand USA, and be age of majority or older in the state, province, or territory of residence. Tour Operator employees are NOT eligible for drawings, and will NOT be considered for additional prizes. Residents of the Province of Quebec are NOT eligible for drawings, and will NOT be considered for additional prizes.',
      body3:
        'Reward issuance may require proof of accreditation as a retail/home-based travel counselor. Available rewards are subject to change during the course of the program.',
      body4: 'Privacy and Use of Personal Information',
      body5:
        'Participating agents (i) grants to the Rewarder the right to use his/her name, city, state, province, postal code, age of majority confirmation, telephone number and e-mail address for including but not limited to contacting and announcing the Awardees and provision of awards; (ii) grants to the Awardee the right to use his/her personal information for publicity and promotional purposes relating to the awards, in any and all media now known or hereafter devised, without further compensation unless prohibited by law; and (iii) acknowledges that the Awardees may disclose his/her personal information to third-party agents and service providers in connection with any of the activities listed in (i) and (ii) above.',
      button: 'Return to Rewards',
    },
    thankYouPage: {
      thanks: 'Thank you',
      congrats: 'Congratulations, ',
      body: 'your booking has been received and sent to the campaign supervisor for verification.',
      link: 'Please note to be a winner, you must have completed the Essential Modules of the Bahamas Specialist Program',
    },
    menu: {
      home: 'Rewards\nHome',
      achievements: 'Training\nAchievements',
      bookings: 'Badge\nIncentives',
      form: 'Submit\nBookings',
    },
  },
  errors: {
    contextError: '{hook} must be used within a {provider}',
    noResultsFound: 'No results found...',
  },
  searchModal: {
    search: 'Search',
    subtitle: 'Look through all content',
    pages: 'USA Discovery Program',
    partnerPages: 'Partner Programs',
    salesCompanion: 'Sales Companion Items',
    exhibitionTiles: 'Partner Showcases',
    noResults: 'No results found...',
  },
  facts: {
    title: 'Did you know?',
  },
  badgeView: {
    other: 'Regional Partners',
    unlock: 'Start completing training items to receive badges',
    title: 'Training Achievements',
    subtitle:
      'Welcome to your Achievements dashboard, where you can view, track and download your diploma and specialization badges.',
    viewBadge: 'View Status',
    badgeDisplayTitle: 'METALLIC REWARDS STATUS',
    badgeAchievement: 'You have achieved {rank} Status! Click the icon on the right to view and share your status.',
    badgesCompleteTitle: 'Your specialization badges',
    badgesCompleteSubtitle: 'Click the icons to view, save and share your badges.',
    badgesIncompleteSubtitle: 'Earn more badges by completing these chapters.',
    bronze: 'Bronze',
    silver: 'Silver',
    gold: 'Gold',
    platinum: 'Platinum',
    diploma: 'Diploma',
    experiencesBadgesSectionTitle: 'The Experiences Badges',
    itinerariesBadgesSectionTitle: 'Itineraries Badges',
    partnerSpecializationBadgesSectionTitle: 'Partner Specialization Badges',
    complete: 'COMPLETE',
  },
  diplomaButton: {
    unlocked: 'View Diploma',
    locked: 'Diploma',
  },
  missing: {
    discover: 'Discover',
    pacific: 'Pacific',
    west: 'West',
    southwest: 'Southwest',
    midwest: 'Midwest',
    south: 'Southeast',
    northeast: 'Northeast',
    territories: 'Territories',
    shoppingAttractions: 'Shopping & Attractions',
    gettingAround: 'Getting Around',
    regionalPartners: 'Regional Partners',
    greatOutdoors: 'Great Outdoors',
    winterSports: 'Winter Sports',
    coastalEscapes: 'Coastal Escapes',
    flyDrive: 'Fly-Drive',
    foodDrink: 'Food & Drink',
    luxury: 'Luxury',
    musicCultureHeritage: 'Music, Culture & Heritage',
    nationalParks: 'National Parks',
    regionMap: 'Region Map',
    videos: 'Videos',
    images: 'Images',
    incentives: 'Incentives',
    southeast: 'Southeast',
  },
};
